import React from "react";

const getSizeStyle = (sx, style) => ({
  width: sx?.fontSize || style?.width,
  height: sx?.fontSize || style?.height,
  ...style,
});

export function TotalDevicesStatsIcon({ sx, style, ...props }) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={getSizeStyle(sx, style)}
      {...props}
    >
      <path
        d="M4.4 4.4H4.4085M4.4 14.6H4.4085M2.7 1H16.3C17.2383 1 18 1.76174 18 2.7V6.1C18 7.03826 17.2383 7.8 16.3 7.8H2.7C1.76174 7.8 1 7.03826 1 6.1V2.7C1 1.76174 1.76174 1 2.7 1ZM2.7 11.2H16.3C17.2383 11.2 18 11.9617 18 12.9V16.3C18 17.2383 17.2383 18 16.3 18H2.7C1.76174 18 1 17.2383 1 16.3V12.9C1 11.9617 1.76174 11.2 2.7 11.2Z"
        stroke="#2563EB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function InstalledDevicesStatsIcon({ sx, style, ...props }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={getSizeStyle(sx, style)}
      {...props}
    >
      <path
        d="M5.16797 8.83301L7.66797 10.833L11.668 5.33301M15.834 8.33301C15.834 12.4724 12.4733 15.833 8.33398 15.833C4.19462 15.833 0.833984 12.4724 0.833984 8.33301C0.833984 4.19365 4.19462 0.833008 8.33398 0.833008C12.4733 0.833008 15.834 4.19365 15.834 8.33301Z"
        stroke="#F59E0B"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ActiveDevicesStatsIcon({ sx, style, ...props }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={getSizeStyle(sx, style)}
      {...props}
    >
      <path
        d="M5.16797 8.83301L7.66797 10.833L11.668 5.33301M15.834 8.33301C15.834 12.4724 12.4733 15.833 8.33398 15.833C4.19462 15.833 0.833984 12.4724 0.833984 8.33301C0.833984 4.19365 4.19462 0.833008 8.33398 0.833008C12.4733 0.833008 15.834 4.19365 15.834 8.33301Z"
        stroke="#22C55E"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DeviceIssuesStatsIcon({ sx, style, ...props }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={getSizeStyle(sx, style)}
      {...props}
    >
      <path
        d="M8.5 8.5V4.75M8.5 11.2795V11.3125M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z"
        stroke="#DC2626"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AvgUptimeStatsIcon({ sx, style, ...props }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={getSizeStyle(sx, style)}
      {...props}
    >
      <path
        d="M15.1992 4L4.19922 15"
        stroke="#3B82F6"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <circle cx="12.1992" cy="16" r="2" fill="#3B82F6" />
      <circle cx="8.19922" cy="3" r="2" fill="#3B82F6" />
    </svg>
  );
}

export const SimExpiryStatsIcon = DeviceIssuesStatsIcon;

export function TotalAssetsStatsIcon({ sx, style, ...props }) {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={getSizeStyle(sx, style)}
      {...props}
    >
      <path
        d="M0 16V14H10V16H0ZM3 13C2.45 13 1.97917 12.8042 1.5875 12.4125C1.19583 12.0208 1 11.55 1 11V2C1 1.45 1.19583 0.979167 1.5875 0.5875C1.97917 0.195833 2.45 0 3 0H17C17.55 0 18.0208 0.195833 18.4125 0.5875C18.8042 0.979167 19 1.45 19 2H3V11H10V13H3ZM18 14V6H14V14H18ZM13.5 16C13.0833 16 12.7292 15.8542 12.4375 15.5625C12.1458 15.2708 12 14.9167 12 14.5V5.5C12 5.08333 12.1458 4.72917 12.4375 4.4375C12.7292 4.14583 13.0833 4 13.5 4H18.5C18.9167 4 19.2708 4.14583 19.5625 4.4375C19.8542 4.72917 20 5.08333 20 5.5V14.5C20 14.9167 19.8542 15.2708 19.5625 15.5625C19.2708 15.8542 18.9167 16 18.5 16H13.5ZM16 8.5C16.2167 8.5 16.3958 8.425 16.5375 8.275C16.6792 8.125 16.75 7.95 16.75 7.75C16.75 7.53333 16.6792 7.35417 16.5375 7.2125C16.3958 7.07083 16.2167 7 16 7C15.8 7 15.625 7.07083 15.475 7.2125C15.325 7.35417 15.25 7.53333 15.25 7.75C15.25 7.95 15.325 8.125 15.475 8.275C15.625 8.425 15.8 8.5 16 8.5Z"
        fill="#008C23"
      />
    </svg>
  );
}

export function OnlineActiveStatsIcon({ sx, style, ...props }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={getSizeStyle(sx, style)}
      {...props}
    >
      <path
        d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
        fill="#008C23"
      />
    </svg>
  );
}

export function InactiveAssetsStatsIcon({ sx, style, ...props }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={getSizeStyle(sx, style)}
      {...props}
    >
      <path
        d="M7 14H9V6H7V14ZM11 14H13V6H11V14ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
        fill="#45474C"
      />
    </svg>
  );
}

export function InAlertStatsIcon({ sx, style, ...props }) {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={getSizeStyle(sx, style)}
      {...props}
    >
      <path
        d="M0 19L11 0L22 19H0ZM3.45 17H18.55L11 4L3.45 17ZM11 16C11.2833 16 11.5208 15.9042 11.7125 15.7125C11.9042 15.5208 12 15.2833 12 15C12 14.7167 11.9042 14.4792 11.7125 14.2875C11.5208 14.0958 11.2833 14 11 14C10.7167 14 10.4792 14.0958 10.2875 14.2875C10.0958 14.4792 10 14.7167 10 15C10 15.2833 10.0958 15.5208 10.2875 15.7125C10.4792 15.9042 10.7167 16 11 16ZM10 13H12V8H10V13Z"
        fill="#EE3B2B"
      />
    </svg>
  );
}
